import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import { AlliancePage } from 'views/Alliance/AlliancePage';
import { GeneralLaw } from 'views/Home/GeneralLaw';
import { GuidelinesPage } from 'views/Home/GuidelinesPage';
import { StructureProcedure } from 'views/Home/StructureProcedurePage';

const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

const DashboardRouters = [
  {
    path: 'alliance',
    element: <AlliancePage />
  },
  {
    path: 'structureProcedure',
    element: <StructureProcedure />
  },
  {
    path: 'law',
    element: <GeneralLaw />
  },
  {
    path: 'guidelines',
    element: <GuidelinesPage />
  },
  {
    path: 'dashboard',
    element: <DashboardDefault />
  }
];

export default DashboardRouters;
